import {calcUserScore, filterObjectByParams} from 'helpers/common-helper';
import BasePlayer from 'services/sports/default/base-player';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import Action from 'actions';
import {getDefaultExposure} from 'helpers/player-helper';
import {SearchRuleBuilder as RuleBuilder} from 'services/search-rule-builder';
import NumberHelper from 'helpers/number-helper';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class Player extends BasePlayer {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('dominator');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer.adminPoints);

        return {
            ...expandedPlayer,
            starting: NumberHelper.int(expandedPlayer.starting, 0),
            p1: NumberHelper.int(expandedPlayer.p1, 0),
            p2: NumberHelper.int(expandedPlayer.p2, 0),
            longRun: NumberHelper.int(expandedPlayer.longRun, 0),
            userPoints: userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            getDominator() {
                let paramName = this.getPropNameOfMode('dominator');
                return this[paramName];
            },
            resetDominator() {
                this.dominator = this.originalDominator;
            },
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('dominators')) {
            dispatch(
                Action.do('updatePlayerParams', data.dominators, {
                    saveFiltersToStorage: ['playersData'],
                }),
            );
        }
    }

    preparePoolsOfPlayers({incomingValues: {players, filterPlayersBeforePreparingPools}}) {
        if (!filterPlayersBeforePreparingPools) {
            return this.exec('createPoolsOfPlayers', {
                players: Object.values(players),
            });
        }

        const params = {
            ...RuleBuilder.callback('playerId', function (player) {
                return !player.isExcludedAnywhere();
            }),
        };

        players = filterObjectByParams(players, params, true);

        return this.exec('createPoolsOfPlayers', {
            players,
        });
    }
}
